module.exports = __webpack_public_path__ + "media/images/athletes/3870-7b845dbb7e1b0e3b9cf992a721473801.png";